export default __webpack_public_path__ + "static/media/logo.8639eb00.png";